import {axiosPost}  from "./axiosFunctions";

const loginUrl = "/api/admin/login"

export const loginAPI = async (param) =>{
        const response = await axiosPost(loginUrl,param);   
        return response;
}